function extrairId (valor) {
  if (valor === null || valor === undefined || valor === '') {
    return null
  }
  if (typeof valor === 'number' || typeof valor === 'string') {
    return valor
  }
  if (typeof valor === 'object' && valor.id !== undefined && valor.id !== null) {
    return valor.id
  }
  return null
}

function idDaAcao (item) {
  if (!item) {
    return null
  }
  if (item.acao_sistema_id !== undefined && item.acao_sistema_id !== null && item.acao_sistema_id !== '') {
    return extrairId(item.acao_sistema_id)
  }
  return extrairId(item.acao_sistema)
}

function normalizarVinculo (item) {
  if (!item || typeof item !== 'object') {
    return item
  }

  const normalizado = {
    ...item,
    modulo_id: item.modulo_id != null && item.modulo_id !== '' ? extrairId(item.modulo_id) : extrairId(item.modulo),
    acao_sistema_id: idDaAcao(item)
  }

  if (item.usuario_id != null || item.usuario != null) {
    normalizado.usuario_id = item.usuario_id != null && item.usuario_id !== '' ? extrairId(item.usuario_id) : extrairId(item.usuario)
  }
  if (item.papel_id != null || item.papel != null) {
    normalizado.papel_id = item.papel_id != null && item.papel_id !== '' ? extrairId(item.papel_id) : extrairId(item.papel)
  }

  return normalizado
}

function normalizarListaPermissao (lista) {
  if (!Array.isArray(lista)) {
    return []
  }

  return lista.map(modulo => {
    const copia = {...modulo}
    if (Array.isArray(copia.moduloUsuarioAcaos)) {
      copia.moduloUsuarioAcaos = copia.moduloUsuarioAcaos.map(normalizarVinculo)
    }
    if (Array.isArray(copia.modulo_papel_acao)) {
      copia.modulo_papel_acao = copia.modulo_papel_acao.map(normalizarVinculo)
    }
    return copia
  })
}

function converterParaEnvio (dados) {
  const vistos = new Set()

  return (dados || [])
    .map(modulo => {
      if (!modulo) {
        return []
      }

      const vinculosUsuario = Array.isArray(modulo.moduloUsuarioAcaos) ? modulo.moduloUsuarioAcaos : null
      const vinculosPapel = Array.isArray(modulo.modulo_papel_acao) ? modulo.modulo_papel_acao : null
      const usarUsuario = vinculosUsuario !== null && (
        vinculosPapel === null ||
        vinculosUsuario.length > 0 ||
        vinculosPapel.length === 0
      )

      if (usarUsuario) {
        return vinculosUsuario.map(mua => ({
          modulo: mua.modulo_id != null && mua.modulo_id !== '' ? extrairId(mua.modulo_id) : extrairId(mua.modulo),
          usuario: mua.usuario_id != null && mua.usuario_id !== '' ? extrairId(mua.usuario_id) : extrairId(mua.usuario),
          acao_sistema: idDaAcao(mua)
        }))
      }

      if (vinculosPapel !== null) {
        return vinculosPapel.map(mpa => ({
          modulo: mpa.modulo_id != null && mpa.modulo_id !== '' ? extrairId(mpa.modulo_id) : extrairId(mpa.modulo),
          papel: mpa.papel_id != null && mpa.papel_id !== '' ? extrairId(mpa.papel_id) : extrairId(mpa.papel),
          acao_sistema: idDaAcao(mpa)
        }))
      }

      return []
    })
    .flat()
    .filter(item => item && item.modulo != null && item.modulo !== '' && item.acao_sistema != null && item.acao_sistema !== '')
    .filter(item => {
      const chave = `${item.modulo}-${item.acao_sistema}-${item.usuario || ''}-${item.papel || ''}`
      if (vistos.has(chave)) {
        return false
      }
      vistos.add(chave)
      return true
    })
}

function buscarFilhos (pai, lista) {
  pai.filhos = lista.filter(item => item.modulo_pai.id === pai.id).sort((a, b) => a.nome < b.nome)
  pai.filhos.map(item => buscarFilhos(item, lista))

  return pai
}

function montarArvore (lista) {
  if (!lista) {
    return []
  }

  const arvore = lista.filter(item => item.situacao !== 'I' && typeof item.modulo_pai === 'undefined').sort((a, b) => a.nome < b.nome)
  if (arvore.length === 0) {
    return lista
  }
  return arvore.map(pai => buscarFilhos({ ...pai }, lista.filter(item => typeof item.modulo_pai !== 'undefined')))
}

export {
  extrairId,
  idDaAcao,
  normalizarListaPermissao,
  converterParaEnvio,
  buscarFilhos,
  montarArvore
}
